import React from 'react';

const SearchEmptyIcon = () => (
  <svg width="147" height="147" viewBox="0 0 147 147">
    <mask
      id="mask0_10200_3908"
      style={{ maskType: 'luminance' }}
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="147"
      height="147"
    >
      <path
        d="M73.5 0.799805C113.82 0.799805 146.5 33.4798 146.5 73.7998C146.5 114.12 113.82 146.8 73.5 146.8C33.18 146.8 0.5 114.12 0.5 73.7998C0.5 33.4798 33.18 0.799805 73.5 0.799805Z"
        fill="white"
      />
    </mask>
    <g mask="url(#mask0_10200_3908)">
      <mask
        id="mask1_10200_3908"
        style={{ maskType: 'luminance' }}
        maskUnits="userSpaceOnUse"
        x="17"
        y="17"
        width="113"
        height="113"
      >
        <path
          d="M73.5 17.7998C104.43 17.7998 129.5 42.8698 129.5 73.7998C129.5 104.73 104.43 129.8 73.5 129.8C42.57 129.8 17.5 104.73 17.5 73.7998C17.5 42.8698 42.57 17.7998 73.5 17.7998Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask1_10200_3908)">
        <path
          d="M73.5 17.7998C104.43 17.7998 129.5 42.8698 129.5 73.7998C129.5 104.73 104.43 129.8 73.5 129.8C42.57 129.8 17.5 104.73 17.5 73.7998C17.5 42.8698 42.57 17.7998 73.5 17.7998Z"
          fill="url(#paint0_linear_10200_3908)"
        />
        <path
          d="M73.5 17.7998C104.43 17.7998 129.5 42.8698 129.5 73.7998C129.5 104.73 104.43 129.8 73.5 129.8C42.57 129.8 17.5 104.73 17.5 73.7998C17.5 42.8698 42.57 17.7998 73.5 17.7998Z"
          fill="#F0F0F0"
        />
        <path
          d="M105.5 45.7998H41.5C39.2909 45.7998 37.5 47.5907 37.5 49.7998V125.8C37.5 128.009 39.2909 129.8 41.5 129.8H105.5C107.709 129.8 109.5 128.009 109.5 125.8V49.7998C109.5 47.5907 107.709 45.7998 105.5 45.7998Z"
          fill="white"
        />
        <path
          d="M65.5 59.7998H47.5C46.3954 59.7998 45.5 60.6952 45.5 61.7998V65.7998C45.5 66.9044 46.3954 67.7998 47.5 67.7998H65.5C66.6046 67.7998 67.5 66.9044 67.5 65.7998V61.7998C67.5 60.6952 66.6046 59.7998 65.5 59.7998Z"
          fill="#F0F0F0"
        />
        <path
          d="M47.5 75.7998H67.5C68.6 75.7998 69.5 76.6998 69.5 77.7998C69.5 78.8998 68.6 79.7998 67.5 79.7998H47.5C46.4 79.7998 45.5 78.8998 45.5 77.7998C45.5 76.6998 46.4 75.7998 47.5 75.7998Z"
          fill="#F5F5F5"
        />
        <path
          d="M47.5 85.7998H79.5C80.6 85.7998 81.5 86.6998 81.5 87.7998C81.5 88.8998 80.6 89.7998 79.5 89.7998H47.5C46.4 89.7998 45.5 88.8998 45.5 87.7998C45.5 86.6998 46.4 85.7998 47.5 85.7998Z"
          fill="#F5F5F5"
        />
        <path
          d="M57.5 115.8H79.5C80.6 115.8 81.5 116.7 81.5 117.8C81.5 118.9 80.6 119.8 79.5 119.8H57.5C56.4 119.8 55.5 118.9 55.5 117.8C55.5 116.7 56.4 115.8 57.5 115.8Z"
          fill="#F5F5F5"
        />
        <path
          d="M47.5 95.7998H99.5C100.6 95.7998 101.5 96.6998 101.5 97.7998C101.5 98.8998 100.6 99.7998 99.5 99.7998H47.5C46.4 99.7998 45.5 98.8998 45.5 97.7998C45.5 96.6998 46.4 95.7998 47.5 95.7998Z"
          fill="#F5F5F5"
        />
        <path
          d="M47.5 105.8H99.5C100.6 105.8 101.5 106.7 101.5 107.8C101.5 108.9 100.6 109.8 99.5 109.8H47.5C46.4 109.8 45.5 108.9 45.5 107.8C45.5 106.7 46.4 105.8 47.5 105.8Z"
          fill="#F5F5F5"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M97.1992 75.4897C93.1392 79.5497 86.5593 79.5497 82.4993 75.4897C78.4393 71.4297 78.4393 64.8497 82.4993 60.7897C86.5593 56.7297 93.1392 56.7297 97.1892 60.7897C101.249 64.8497 101.249 71.4297 97.1892 75.4897H97.1992ZM99.2793 58.7097C94.0693 53.4997 85.6193 53.4997 80.4093 58.7097C75.1993 63.9197 75.1893 72.3697 80.4093 77.5897C85.1493 82.3297 92.5892 82.7597 97.8192 78.8697C98.3292 78.4897 98.8193 78.0597 99.2893 77.5897C99.7593 77.1197 100.189 76.6297 100.569 76.1197C104.459 70.8897 104.029 63.4597 99.2893 58.7197L99.2793 58.7097Z"
          fill="#F0F0F0"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M100.851 75.6997L104.801 79.6497L102.001 82.4497L98.0508 78.4997C98.5708 78.1097 99.0708 77.6797 99.5508 77.1997C100.031 76.7197 100.461 76.2197 100.851 75.6997Z"
          fill="#F0F0F0"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M119.209 96.4896L118.989 96.7096C117.539 98.1596 115.169 98.1596 113.719 96.7096L103.099 86.0896C101.589 84.5796 101.589 82.1196 103.099 80.5996C104.609 79.0796 107.069 79.0896 108.589 80.5996L119.209 91.2196C120.659 92.6696 120.659 95.0396 119.209 96.4896Z"
          fill="#D9D9D9"
        />
      </g>
    </g>
    <defs>
      <linearGradient
        id="paint0_linear_10200_3908"
        x1="73.5"
        y1="17.7998"
        x2="73.5"
        y2="129.8"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FBFBFB" />
        <stop offset="1" stopColor="#EEEEEE" />
      </linearGradient>
    </defs>
  </svg>
);

export default SearchEmptyIcon;
